import { Component, ElementRef, ViewChild } from "@angular/core";
import Swal from 'sweetalert2';
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { mdlTravelCancellationInfoRes } from "../../../Models/mdlTravelCancellationInfoRes";
import { mdlStatus } from "../../../Models/CompAttachmentsMdl";
import { mdlCalculateTravelRefundRes } from "../../../Models/mdlCalculateTravelRefundRes";
import { userService } from "../../../Services/userService";
import { restURL } from "../../../Models/restURL";
import { APIService } from "../../../Services/api.service";
import { EncryptionService } from "../../../Services/EncryptionService";
import { mdlOTPReq } from "../../../Models/mdlOTPReq";
import { mdlPayloadRequest } from "../../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../../Models/mdlPayloadResponse";
import { OtpVerifyReq } from "../../../Models/OtpVerifyReq";
import { mdlGetTravelDetailsAddEndorsemenRes, mdlPolicyPassengerDetails } from "../../../Models/mdlGetTravelDetailsAddEndorsemenRes";
import { Subscription } from "rxjs/Subscription";
import { authenticationService } from "../../../Services/authenticationService";
import { LanguageService } from "../../../Services/languageService";
import { mdlAddExtRedPolicyTravelRes } from "../../../Models/mdlAddExtRedPolicyTravelRes";
import { mdlEndorsementDetailsDDLRes } from "../../../Models/mdlEndorsementDetailsDDLRes";
import { mdlChangeInGeneralInfo } from "../../../Models/mdlGetChangeInGeneralInfoRes";

// import { mdlGetTrav}

@Component({
    selector: "TravelAddEndorsement",
    templateUrl: "./TravelAddEndorsement.html",
    styleUrls: ["./TravelAddEndorsement.css"]

})

export class TravelAddEndorsement {
    public objBindInfoRes = new mdlGetTravelDetailsAddEndorsemenRes();
    public objEndReq: any;
    public minDate: string = "";
    public UserId: string = "";
    maxDate = new Date();
    public LngSubscription: Subscription;
    public IsShowLoading: boolean = false;
    public Lng: any;
    public DDL = new mdlEndorsementDetailsDDLRes();
    public objBinRes = new mdlChangeInGeneralInfo();
    public EndorsementDate: string = "";
    public NewToDate: any;
    public IsSubmitted: boolean = false;
    public PolicyExtREdFlag: string = "";
    public RefundPremium: any;
    public AdditionalPremium: any;
    public VatAmount: any;
    public TotalPremium: any;
    public TotalDays: any | number;
    public Days: any | number;
    public objRes = new mdlAddExtRedPolicyTravelRes();
    public objEndorsementList: any;
    public objEndorsementMasterList: any;
    // public objPolicyDet: mdlSearchPolicyRes = new mdlSearchPolicyRes();
    public LOB = "";
    EditMemberModal: boolean = false;
    public tempId: any;
    showMemberError = false;
    public oneMember = new mdlPolicyPassengerDetails();

    constructor(public translate: TranslateService, private userinfo: userService, private AuthSer: authenticationService, private APISer: APIService, private Decriptsrvc: EncryptionService, private router: Router, private lngService: LanguageService) {
        let sessionItem: any = sessionStorage.getItem("objEndReq");
        // this.objEndReq = JSON.parse(this.Decriptsrvc.DecriptObject(sessionItem));

        this.objEndReq = JSON.parse(this.Decriptsrvc.DecriptObject(sessionItem));

        this.objEndReq.EndorsementCode = 6;

        let RegNo: any = sessionStorage.getItem("RegNo");
        var rightNow = new Date();
        this.minDate = rightNow.toISOString().slice(0, 10).replace(/-/g, "-");
        // this.UserId = JSON.parse(this.Decriptsrvc.DecriptObject(RegNo));
        this.LngSubscription = this.lngService.grtLng().subscribe(Lng => {
            this.Lng = Lng;
        });
        if (sessionStorage.getItem("Language") != null) {
            this.Lng = sessionStorage.getItem("Language");
        } else {
            this.Lng = "en";
        }
        this.FillDDL();
    }


    async FillDDL() {
        try {
            let Req = {
                UserId: this.UserId,
            }
            this.IsShowLoading = true;
            var APIRes = await this.APISer.ConnectAPI("/LimraEndorsements/FillDDLEndorsementDetails", Req)
            this.IsShowLoading = false;
            var APIStatus = APIRes[0]
            if (APIStatus.StatusCode == "F") {


                swal(APIStatus.StatusDesc, "", "error")
                return;
            }
            this.DDL = APIRes[1];

            await this.GetTravelDetailsAddEndorsement();
        }
        catch { }
        finally {
            this.IsShowLoading = false;
        }

    }

    async GetTravelDetailsAddEndorsement() {

        let regRegNo: any = sessionStorage.getItem("RegNo");
        try {
            this.IsShowLoading = true;
            let Req = {
                PolicyNo: this.objEndReq.PolicyNo,

                // PolicyNo: this.objEndReq.PolicyNo
                // UserId: this.UserId,
                UserId: "1",
                //  UserId: regRegNo,

                // LOB: this.objEndReq.LOB,
                LOB: "60",
                // EndorsementCode: this.objEndReq.EndorsementTypeCode

                EndorsementCode: "6"
            }

            this.IsShowLoading = true;
            var APIRes = await this.APISer.ConnectAPI("/LimraEndorsements/GetTravelDetailsAddEndorsement", Req)
            this.IsShowLoading = false;
            var APIStatus = APIRes[0]
            if (APIStatus.StatusCode == "F") {
                swal(APIStatus.StatusDesc, "", "error")
                return;
            }
            this.objBindInfoRes = APIRes[1];

            if (this.objBindInfoRes.st.StatusCode == "F") {
                Swal(this.objBindInfoRes.st.StatusDesc, "", "info")
                this.router.navigate(["Enquiry/Menu/PolicyList"]);
                return;
            }
            this.objBinRes = this.objBindInfoRes.GeneralInfo;
            if (this.objBinRes.PolicyFromDate > this.minDate) {
                this.EndorsementDate = this.objBinRes.PolicyFromDate;
            } else { this.EndorsementDate = this.minDate }
            for (let obj of this.objBindInfoRes.PassengerDetails) {
                // obj.DOB = this.ConvertYYYYDDMM(obj.DOB)
            }
            this.NewToDate = this.objBinRes.PolicyToDate;

        }
        catch { }
        finally {
            this.IsShowLoading = false;
        }
    }
    formatDate(date: Date): string {
        const yyyy = date.getFullYear();
        const mm = ('0' + (date.getMonth() + 1)).slice(-2);
        const dd = ('0' + date.getDate()).slice(-2);
        return `${yyyy}-${mm}-${dd}`;
    }

    ConvertYYYYDDMM(date: any) {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;

        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        var dateString = yyyy + '-' + mm + '-' + dd;
        return dateString;
    }


    // GoToEndorsement(obj: any) {
    //     if (this.objEndorsementList != null && this.objEndorsementList.length > 0) {
    //         if (this.objEndorsementList.filter((t: { Decisionstatus: string }) => t.Decisionstatus === "PENDING").length > 0) {
    //             swal("Another Endorsement Is In Process", "", "info");
    //             return;
    //         }
    //     }

    //     const objEndReq = {
    //         PolicyNo: this.objPolicyDet.PolicyNo,
    //         EndorsementType: obj.EndorsementDesc,
    //         EndorsementTypeCode: obj.EndorsementCode,
    //         InsuredName: this.objPolicyDet.InsuredName,
    //         CustomId: this.objPolicyDet.CustomId,
    //         LOB: this.LOB,
    //         ChassisNo: this.objPolicyDet.ChassisNo
    //     };


    //     sessionStorage.setItem("objEndReq", this.Decriptsrvc.EncriptObject(JSON.stringify(objEndReq)));


    //     if (this.LOB === "60") {

    //         if (obj.EndorsementCode === "2") {
    //             this.router.navigate(['Enquiry/Menu/PolicyList/TravelCancellation']);
    //         } else if (obj.EndorsementCode === "6" || obj.EndorsementCode === "7") {
    //             this.router.navigate(['Enquiry/Menu/PolicyList/TravelAddEndorsement']);
    //         } else {
    //             swal("Coming Soon", obj.EndorsementDesc + " is coming soon", "info");
    //         }
    //     } else {

    //         swal("Coming Soon", "This Line of Business is not yet supported.", "info");
    //     }
    // }


    async Submit( ) { 
        try {
            this.IsSubmitted = true;
            // if (!Form.valid) {
            //     let Contorl: string;
            //     let ElementKey: string;
            //     Object.keys(Form.controls).forEach(key => {
            //         if (Form.controls[key].errors != undefined) {
            //             if (Contorl == null || Contorl == undefined) {
            //                 Contorl = key.substring(3, key.length);
            //                 ElementKey = key;
            //             }
            //         }
            //     });
            // }
            // if (!Form.valid) {
            //     return;
            // }

            // if (this.objEndReq.EndorsementTypeCode == 6) {
                this.objBindInfoRes.GeneralInfo.UserId = this.UserId
                this.IsShowLoading = true;
                var APIRes = await this.APISer.ConnectAPI("/LimraEndorsements/AddChangeInPassInfoTravel", this.objBindInfoRes)
                this.IsShowLoading = false;
                var APIStatus = APIRes[0]
                if (APIStatus.StatusCode == "F") {
                    swal(APIStatus.StatusDesc, "", "error")
                    return;
                }
                var Res = APIRes[1];
                if (Res.StatusCode == "S") {
                    swal(Res.StatusDesc, "", "success")
                    this.router.navigate(['/NewDashboard/Policy']);
                    return;
                } else {
                    swal(Res.StatusDesc, "", "info")
                }

           // }
            if (this.objEndReq.EndorsementTypeCode == 7) {
                if (this.Days == undefined || this.Days == 0 || this.Days == null) {
                    this.AdditionalPremium = null
                    this.RefundPremium = null
                    this.TotalPremium = null
                    this.VatAmount = null
                    this.NewToDate = this.objBinRes.PolicyToDate;
                    swal("Enter Days", "", "info")
                    this.TotalDays = null;
                    return;
                }
                var Req = {
                    PolicyNo: this.objBindInfoRes.GeneralInfo.PolicyNo,
                    UserId: this.UserId,
                    Flag: this.PolicyExtREdFlag,
                    Days: this.Days,
                    AdditionalPremium: this.AdditionalPremium,


                    RefundPremium: this.RefundPremium,
                    VatAmount: this.VatAmount,
                    TotalPremium: this.TotalPremium,


                    NewToDate: this.NewToDate,
                    Remarks: this.objBindInfoRes.GeneralInfo.RequestNotes,
                    PresentPremium: this.objBinRes.PresentPremium
                }
                this.IsShowLoading = true;
                var APIRes = await this.APISer.ConnectAPI("/LimraEndorsements/AddExtRedPolicyTravel", Req)
                this.IsShowLoading = false;
                var APIStatus = APIRes[0]
                if (APIStatus.StatusCode == "F") {
                    swal(APIStatus.StatusDesc, "", "error")
                    return;
                }
                this.objRes = APIRes[1];
                if (this.objRes.st.StatusCode == "F") {
                    swal(this.objRes.st.StatusDesc, "", "info")
                    return;
                }

                if (this.objRes.st.StatusCode == "S") {
                    swal(this.objRes.st.StatusDesc, "", "info")
                    if (this.PolicyExtREdFlag == "Extension") {
                        this.objRes.PaymentObj.UserId = this.UserId;
                        if (Number(this.objRes.PaymentObj.TotalPremium) > 0) {
                            sessionStorage.setItem("NavFrom", "PR");
                            sessionStorage.setItem("PaymentObj", this.Decriptsrvc.EncriptObject(JSON.stringify(this.objRes.PaymentObj)));
                            sessionStorage.setItem("CurrentRoute", "HyperpayPayment");
                            this.IsShowLoading = true;
                            this.router.navigate(['Payments/Menu/HyperpayPayment']).then(value => { this.IsShowLoading = false; });
                            return;
                        }
                    }
                }
                if (this.objRes.st.StatusCode == "S") {
                    swal(this.objRes.st.StatusDesc, "", "info")
                    if (this.PolicyExtREdFlag == "Reduction") {
                        this.IsShowLoading = true;
                        this.router.navigate(['/NewDashboard/Policy']);
                        return;


                    }
                }
            }


        } catch (e) { }
        finally {
            this.IsShowLoading = false;
        }

    }

    // Back() {
    //     ///NewDashboard/
    //     this.router.navigate(["Enquiry/Menu/PolicyList"]);
    // }

    Back() {
        this.router.navigate(['/NewDashboard/Policy']);
    }
    EditMember(obj: mdlPolicyPassengerDetails) {
        this.oneMember = new mdlPolicyPassengerDetails();
        this.EditMemberModal = true;
        this.tempId = obj.IdentityNo;

        this.oneMember.IdentityNo = obj.IdentityNo;
        this.oneMember.Name = obj.Name;
        //  this.oneMember.DOB = new Date(obj.DOB);
        // this.oneMember.DOB = this.formatDate(obj.DOB);
        this.oneMember.Sex = obj.Sex;
        this.oneMember.RelationshipCode = obj.RelationshipCode.toString();
        this.oneMember.Nationality = obj.Nationality.toString();
        this.oneMember.PassportNo = obj.PassportNo;
    }
    validateMemberIqamaNo() {
        var re = new RegExp("^[1,2]{1}[0-9]{9}$");
        if (!re.test(this.oneMember.IdentityNo)) return 'regex'
        return '';
    }
    validateMemberName() {
        if (!this.oneMember.Name) {
            return "required"
        }
        return "";
    }
    validateMemberDOB() {
        // if (!this.oneMember.DOB) {
        //     return "required"
        // }
        return "";
    }
    validateMemberGender() {
        if (!this.oneMember.Sex) {
            return "required"
        }
        return "";
    }
    validateMemberRelation() {
        if (!this.oneMember.RelationshipCode) {
            return "required"
        }
        return "";
    }
    validateMemberNationality() {
        if (!this.oneMember.Nationality) {
            return "required"
        }
        return "";
    }
    validateMemberPassport() {
        if (!this.oneMember.PassportNo) {
            return "required"
        }
        return "";
    }

    CheckIDAlreadyUsed(IdentityNo: string) {

        let IsIDSameWithInsured = this.objBinRes.Insured_IDNo === IdentityNo;
        if (IsIDSameWithInsured) {
            swal("Id is already used for Insured", "Insured Id cannot be used as member Id", "warning");
            this.oneMember.IdentityNo = ""
        }
        this.objBindInfoRes.PassengerDetails.forEach((obj: mdlPolicyPassengerDetails) => {
            if (obj.IdentityNo == IdentityNo) {
                swal("Member with given Id already added", "Duplicate Id number are not allowed.", "warning");
                this.oneMember.IdentityNo = "";
            }
        })
    }
    Cancel() {
        this.oneMember = new mdlPolicyPassengerDetails();
        this.tempId = "";
        this.EditMemberModal = false;
        this.showMemberError = false;
    }
    UPdateMember() {

        this.showMemberError = true;

        if (this.validateMemberIqamaNo() != "") return;
        // if (this.validateMemberName() != "") return;
        // if (this.validateMemberDOB() != "") return;
        // if (this.validateMemberGender() != "") return;
        // if (this.validateMemberRelation() != "") return;
        // if (this.validateMemberNationality() != "") return;
        if (this.validateMemberPassport() != "") return;
        this.objBindInfoRes.PassengerDetails = this.removeByAttr(this.objBindInfoRes.PassengerDetails, "IdentityNo", this.tempId);

        this.tempId = "";
        this.objBindInfoRes.PassengerDetails.unshift(this.oneMember);
        this.oneMember = new mdlPolicyPassengerDetails();
        this.EditMemberModal = false;
        this.showMemberError = false;
    }

    removeByAttr(arr: any, attr: any, value: any) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {

                arr.splice(i, 1);

            }
        }
        return arr;
    }
    DDlPeriodChange() {
        this.Days = null;
        this.AdditionalPremium = null
        this.RefundPremium = null
        this.TotalPremium = null
        this.VatAmount = null
        this.NewToDate = this.objBinRes.PolicyToDate;
    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelAddEndorsement/TravelAddEndorsement.ts